module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-api"
  }, [(_vm.apiEnabled) ? _c('div', [_c('div', {
    staticClass: "pane"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n        API 信息\n      ")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-width": "160px",
      "label-position": "right"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "API 服务器"
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": true
    },
    model: {
      value: (_vm.form.api_endpoint),
      callback: function($$v) {
        _vm.form.api_endpoint = $$v
      },
      expression: "form.api_endpoint"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Access Key"
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": true
    },
    model: {
      value: (_vm.form.access_key),
      callback: function($$v) {
        _vm.form.access_key = $$v
      },
      expression: "form.access_key"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "API 类型"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.sandbox ? '测试' : '正式'))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "调用统计"
    }
  }, [_c('span', [_vm._v(_vm._s(Number(_vm.form.quotas) - Number(_vm.form.quotas_left)) + "/" + _vm._s(Number(_vm.form.quotas)))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开发文档"
    }
  }, [_c('a', {
    staticClass: "text-btn",
    attrs: {
      "href": "https://ppninja.github.io/saas-docs/#introduction",
      "target": "_blank"
    }
  }, [_vm._v("点击访问")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pane"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n        调用配置\n      ")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-width": "160px",
      "label-position": "right"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "回调地址",
      "error": _vm.errors.first('notify_url')
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "可选"
    },
    model: {
      value: (_vm.form.notify_url),
      callback: function($$v) {
        _vm.form.notify_url = $$v
      },
      expression: "form.notify_url"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "IP 白名单",
      "error": _vm.errors.first('ip_whitelist')
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "可选"
    },
    model: {
      value: (_vm.form.ip_whitelist),
      callback: function($$v) {
        _vm.form.ip_whitelist = $$v
      },
      expression: "form.ip_whitelist"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save('request')
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pane"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n        生成配置\n      ")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-width": "160px",
      "label-position": "right"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "开放页面控制接口"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "disabled": _vm.form.page_ctrl_api_entitled,
      "content": "请联系管理员打开权限",
      "effect": "dark",
      "placement": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "35px"
    }
  }, [_c('el-switch', {
    attrs: {
      "reserve": "",
      "disabled": true,
      "theme": "info",
      "width": 35,
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.form.page_ctrl_api_entitled),
      callback: function($$v) {
        _vm.form.page_ctrl_api_entitled = $$v
      },
      expression: "form.page_ctrl_api_entitled"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "嵌入js代码"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "console.log('hello, world!');"
    },
    model: {
      value: (_vm.form.injected_code),
      callback: function($$v) {
        _vm.form.injected_code = $$v
      },
      expression: "form.injected_code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save('generate')
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)]) : _c('div', {
    staticClass: "pane"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("您尚未开通 API 服务，"), _c('a', {
    on: {
      "click": _vm.apiApplication
    }
  }, [_vm._v("点击申请")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01c5dff8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/development/index.vue
// module id = 890
// module chunks = 3